export default "__VITE_ASSET__4b3b6d99__"